module.exports = __webpack_public_path__ + "static/media/Sound_16369.15a34614.mp3";